var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeyondwallsLogoirfs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 233.397,
    height: 47.331,
    viewBox: "0 0 233.397 47.331",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1211",
    "data-name": "Group 1211",
    transform: "translate(-66.03 -554.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M570.26,585.3l-7.034,25.061h-.467L555.492,591.4l-7.417,18.962h-.467L540.691,585.3h2.5l5,18.059,7.034-18.059h.5l6.951,18.059,5.1-18.059Z",
    transform: "translate(-312.924 -20.268)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M641.953,622.068h-2.317v-3.186a9.006,9.006,0,0,1-7.277,3.663,8.7,8.7,0,0,1-6.627-2.9,9.73,9.73,0,0,1-2.664-6.9,9.552,9.552,0,0,1,2.722-6.848,8.838,8.838,0,0,1,6.636-2.846,8.423,8.423,0,0,1,7.21,3.884v-3.407h2.317Zm-2.167-9.166a7.54,7.54,0,0,0-2.037-5.354,6.731,6.731,0,0,0-5.13-2.176,6.651,6.651,0,0,0-6.2,3.723,7.636,7.636,0,0,0,0,7.487,7.25,7.25,0,0,0,2.636,2.771,6.776,6.776,0,0,0,3.55.994,7.157,7.157,0,0,0,3.625-.985,6.834,6.834,0,0,0,2.636-2.669,7.757,7.757,0,0,0,.923-3.791",
    transform: "translate(-367.232 -31.97)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M687.419,584.924v24.221h2.352V583.454Z",
    transform: "translate(-409.656 -19.048)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M706.353,584.924v24.221H708.7V583.454Z",
    transform: "translate(-422.139 -19.048)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M730.038,617.085a5.246,5.246,0,0,1-1.583,3.908,5.355,5.355,0,0,1-3.9,1.553,6.386,6.386,0,0,1-5.35-2.624l1.467-1.7a5.049,5.049,0,0,0,3.775,2.044,3.5,3.5,0,0,0,2.336-.875,2.778,2.778,0,0,0,1.023-2.2,3.022,3.022,0,0,0-1.214-2.363,14.376,14.376,0,0,0-2.362-1.427,10.561,10.561,0,0,1-2.944-2.1,4.8,4.8,0,0,1-1.265-3.339,4.69,4.69,0,0,1,1.425-3.535,4.91,4.91,0,0,1,3.542-1.371,7.307,7.307,0,0,1,5.034,2.5l-1.5,1.584a5.334,5.334,0,0,0-3.643-1.84,2.82,2.82,0,0,0-1.913.729,2.312,2.312,0,0,0-.831,1.813q0,1.83,3.46,3.659a12.1,12.1,0,0,1,3.094,2.15,4.834,4.834,0,0,1,1.348,3.43",
    transform: "translate(-430.611 -31.97)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M214.448,603.051a7.428,7.428,0,0,1-1.025,3.794,6.6,6.6,0,0,1-2.792,2.651,10.258,10.258,0,0,1-4.651.87h-6.868V585.3h3.851a19.9,19.9,0,0,1,4.9.443,6.576,6.576,0,0,1,3.45,2.162,5.964,5.964,0,0,1-1.166,8.646,6.809,6.809,0,0,1,4.3,6.5m-6.317-10.659q0-2.556-3.155-2.556h-1.2v5.281h1.013q3.338,0,3.338-2.726m1.717,10.5q0-3.5-5.1-3.5h-.964v6.44h1.164a9.477,9.477,0,0,0,3.241-.41,2.493,2.493,0,0,0,1.662-2.528",
    transform: "translate(-87.736 -20.268)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M271.439,613.26l-.017.886h-14.6a4.912,4.912,0,0,0,1.731,3.165,5.341,5.341,0,0,0,3.463,1.128,6.016,6.016,0,0,0,4.378-1.806l3.829,1.84a9.3,9.3,0,0,1-8.184,4.072A9.273,9.273,0,0,1,252.4,612.9a9.881,9.881,0,0,1,2.642-7.027,8.834,8.834,0,0,1,6.742-2.82,9.229,9.229,0,0,1,6.968,2.794,10.01,10.01,0,0,1,2.683,7.411m-4.6-2.794a4.508,4.508,0,0,0-1.811-2.531,5.2,5.2,0,0,0-3.023-.928,5.357,5.357,0,0,0-3.323,1.08,6.012,6.012,0,0,0-1.661,2.379Z",
    transform: "translate(-122.869 -31.97)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M383.746,612.783a9.96,9.96,0,0,1-1.267,4.907,9.234,9.234,0,0,1-3.475,3.57,9.484,9.484,0,0,1-4.859,1.286,8.926,8.926,0,0,1-6.684-2.836,9.563,9.563,0,0,1-2.734-6.891,9.438,9.438,0,0,1,3.117-7.24,8.958,8.958,0,0,1,6.284-2.522,9.5,9.5,0,0,1,4.825,1.3,9.3,9.3,0,0,1,3.526,3.561,9.787,9.787,0,0,1,1.267,4.864m-4.617.017a5.561,5.561,0,0,0-1.346-3.829,4.947,4.947,0,0,0-7.176.042,5.527,5.527,0,0,0-1.329,3.787,5.618,5.618,0,0,0,1.312,3.821,4.507,4.507,0,0,0,3.588,1.579,4.556,4.556,0,0,0,3.6-1.579,5.571,5.571,0,0,0,1.346-3.821",
    transform: "translate(-196.919 -31.97)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M442.58,622.068h-4.517v-8.117q0-2.535-.083-3.216a4.213,4.213,0,0,0-1.211-2.859,2.85,2.85,0,0,0-1.792-.562q-2.919,0-3.732,3.557a21.535,21.535,0,0,0-.2,3.76v7.436h-4.551V603.532h4.551v1.891a8.39,8.39,0,0,1,5.376-2.368A6.127,6.127,0,0,1,441,604.98a6.667,6.667,0,0,1,1.581,4.839Z",
    transform: "translate(-237.64 -31.97)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M493.876,586.3v6.357a7.686,7.686,0,0,0-5.713-2.521c-.152,0-.3,0-.448.011a7.618,7.618,0,0,0-5.8,2.97,9.766,9.766,0,0,0-.808,1.157,10.754,10.754,0,0,0-1.455,5.639,10.18,10.18,0,0,0,2.381,6.748,7.861,7.861,0,0,0,11.837.528v1.957h4.549v-25.69Zm-1.1,17.434a4.592,4.592,0,0,1-3.655,1.615,4.485,4.485,0,0,1-3.586-1.648,5.731,5.731,0,0,1-1.33-3.839,5.667,5.667,0,0,1,1.312-3.821,4.528,4.528,0,0,1,3.59-1.6,4.608,4.608,0,0,1,3.622,1.538,5.61,5.61,0,0,1,1.362,3.863,5.792,5.792,0,0,1-1.315,3.889",
    transform: "translate(-272.688 -19.049)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M327.51,604.455l-12.8,28.514h-4.7l5.169-11.359-6.9-17.156h4.667l4.709,11.636,5.191-11.636Z",
    transform: "translate(-159.702 -32.893)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M100.165,570.9H85.489V556.07A1.5,1.5,0,0,0,84,554.562H67.523a1.5,1.5,0,0,0-1.493,1.508v32.976a1.5,1.5,0,0,0,1.493,1.508h32.642a1.5,1.5,0,0,0,1.493-1.508V572.4a1.5,1.5,0,0,0-1.493-1.508m-30.845-12a1,1,0,0,1,.995-1.005H81.2a1,1,0,0,1,1,1.005v12H69.32ZM82.2,587.23H70.315a1,1,0,0,1-.995-1.005V574.219H82.2Zm16.169-1.005a1,1,0,0,1-.995,1.005H85.489V574.219H97.373a1,1,0,0,1,.995,1.005Z",
    transform: "translate(0 -0.001)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M146.871,554.561h-8.5a1.159,1.159,0,0,0-.81,1.975l9.078,9.171a1.144,1.144,0,0,0,1.955-.819V556.3a1.727,1.727,0,0,0-1.718-1.735",
    transform: "translate(-46.932 0)",
    fill: "#43a66a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    transform: "translate(164.998 593.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M356.479,670.815h1.209A3.977,3.977,0,0,1,359.1,671a1.444,1.444,0,0,1,.684.586,1.811,1.811,0,0,1,.25.97,1.631,1.631,0,0,1-.328,1.042,1.7,1.7,0,0,1-.889.577,5.076,5.076,0,0,1-1.2.094V676.8h-1.14Zm1.14,2.339h.362a1.957,1.957,0,0,0,.594-.061.524.524,0,0,0,.262-.2.59.59,0,0,0,.1-.341.545.545,0,0,0-.269-.506,1.529,1.529,0,0,0-.724-.118h-.321Z",
    transform: "translate(-356.479 -670.551)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M369.065,675.169h.952v.557a1.185,1.185,0,0,1,.411-.5.988.988,0,0,1,.561-.171,1.041,1.041,0,0,1,.452.114l-.346.956a.761.761,0,0,0-.322-.1.509.509,0,0,0-.433.317,2.907,2.907,0,0,0-.177,1.246l0,.215V679.6h-1.1Z",
    transform: "translate(-364.776 -673.346)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M379.314,675.055a2.344,2.344,0,0,1,1.178.313,2.26,2.26,0,0,1,.861.85,2.286,2.286,0,0,1,.309,1.16,2.324,2.324,0,0,1-.311,1.172,2.241,2.241,0,0,1-.848.852,2.34,2.34,0,0,1-1.184.308,2.208,2.208,0,0,1-1.626-.678,2.347,2.347,0,0,1,.088-3.375A2.223,2.223,0,0,1,379.314,675.055Zm.018,1.045a1.142,1.142,0,0,0-.862.36,1.277,1.277,0,0,0-.344.922,1.3,1.3,0,0,0,.34.936,1.139,1.139,0,0,0,.862.358,1.152,1.152,0,0,0,.868-.362,1.427,1.427,0,0,0,.006-1.857A1.153,1.153,0,0,0,379.332,676.1Z",
    transform: "translate(-370.02 -673.346)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M394.411,675.169v.488a2.087,2.087,0,0,1,.651-.452,1.877,1.877,0,0,1,.749-.15,1.933,1.933,0,0,1,1.473.655,2.376,2.376,0,0,1,.606,1.681,2.316,2.316,0,0,1-.627,1.654,1.972,1.972,0,0,1-1.485.666,1.848,1.848,0,0,1-.712-.136,2.173,2.173,0,0,1-.655-.446v2.087h-1.1v-6.046Zm1.167.911a1.16,1.16,0,0,0-.871.358,1.292,1.292,0,0,0-.346.936,1.331,1.331,0,0,0,.346.954,1.15,1.15,0,0,0,.871.364,1.13,1.13,0,0,0,.857-.37,1.451,1.451,0,0,0,.006-1.878A1.133,1.133,0,0,0,395.578,676.08Z",
    transform: "translate(-380.759 -673.346)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M413.486,677.7h-3.568a1.186,1.186,0,0,0,.413.751,1.3,1.3,0,0,0,.857.279,1.481,1.481,0,0,0,1.07-.436l.936.44a2.215,2.215,0,0,1-.838.734,2.626,2.626,0,0,1-1.16.238,2.293,2.293,0,0,1-1.7-.657,2.239,2.239,0,0,1-.655-1.646,2.313,2.313,0,0,1,.653-1.683,2.195,2.195,0,0,1,1.638-.669,2.276,2.276,0,0,1,1.7.669,2.421,2.421,0,0,1,.655,1.768Zm-1.111-.875a1.116,1.116,0,0,0-.434-.6,1.261,1.261,0,0,0-.752-.232,1.33,1.33,0,0,0-.815.261,1.446,1.446,0,0,0-.408.573Z",
    transform: "translate(-391 -673.346)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M424.343,675.169h.952v.557a1.188,1.188,0,0,1,.411-.5.989.989,0,0,1,.561-.171,1.04,1.04,0,0,1,.452.114l-.346.956a.761.761,0,0,0-.322-.1.509.509,0,0,0-.433.317,2.908,2.908,0,0,0-.177,1.246l0,.215V679.6h-1.1Z",
    transform: "translate(-401.219 -673.346)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M438.819,675.389h1.135l1.15,2.778,1.269-2.778h1.138l-2.773,6.046h-1.147l.91-1.949Z",
    transform: "translate(-410.762 -673.566)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M463.789,671.338l-.844.744a1.2,1.2,0,0,0-.9-.618.549.549,0,0,0-.367.12.348.348,0,0,0-.143.27.462.462,0,0,0,.1.285,7.632,7.632,0,0,0,.835.769q.652.546.791.688a2.4,2.4,0,0,1,.491.67,1.675,1.675,0,0,1,.144.7,1.6,1.6,0,0,1-.509,1.216,1.855,1.855,0,0,1-1.328.48,1.978,1.978,0,0,1-1.114-.313,2.48,2.48,0,0,1-.813-.985l.958-.578q.432.793.994.793a.732.732,0,0,0,.493-.171.508.508,0,0,0,.2-.395.683.683,0,0,0-.151-.407,4.383,4.383,0,0,0-.664-.622,6.657,6.657,0,0,1-1.264-1.231,1.56,1.56,0,0,1-.285-.864,1.414,1.414,0,0,1,.475-1.068,1.645,1.645,0,0,1,1.171-.445,1.845,1.845,0,0,1,.853.207A3.109,3.109,0,0,1,463.789,671.338Z",
    transform: "translate(-424.813 -670.26)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M478.041,677.7h-3.568a1.186,1.186,0,0,0,.413.751,1.3,1.3,0,0,0,.857.279,1.481,1.481,0,0,0,1.07-.436l.936.44a2.214,2.214,0,0,1-.838.734,2.625,2.625,0,0,1-1.16.238,2.293,2.293,0,0,1-1.7-.657,2.239,2.239,0,0,1-.655-1.646,2.313,2.313,0,0,1,.653-1.683,2.194,2.194,0,0,1,1.638-.669,2.276,2.276,0,0,1,1.7.669,2.421,2.421,0,0,1,.655,1.768Zm-1.111-.875a1.118,1.118,0,0,0-.434-.6,1.261,1.261,0,0,0-.752-.232,1.329,1.329,0,0,0-.815.261,1.45,1.45,0,0,0-.408.573Z",
    transform: "translate(-433.559 -673.346)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M501.3,670.039a.678.678,0,0,1,.5.212.728.728,0,0,1,0,1.019.671.671,0,0,1-.495.209.68.68,0,0,1-.5-.214.714.714,0,0,1-.209-.519.707.707,0,0,1,.706-.708Zm-.555,1.823h1.11v4.427h-1.11Z",
    transform: "translate(-451.485 -670.039)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M507.253,675.169h1.11v.454a2.663,2.663,0,0,1,.685-.443,1.653,1.653,0,0,1,.628-.125,1.519,1.519,0,0,1,1.117.46,1.578,1.578,0,0,1,.386,1.155V679.6h-1.1v-1.939a4.871,4.871,0,0,0-.072-1.053.721.721,0,0,0-.247-.4.694.694,0,0,0-.437-.136.82.82,0,0,0-.578.225,1.205,1.205,0,0,0-.335.624,5.03,5.03,0,0,0-.049.9V679.6h-1.11Z",
    transform: "translate(-455.878 -673.346)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M524.821,675.169h1.107v3.793a2.51,2.51,0,0,1-.451,1.652,2.261,2.261,0,0,1-1.827.716,3.2,3.2,0,0,1-1.094-.163,1.964,1.964,0,0,1-.749-.478,1.945,1.945,0,0,1-.452-.767h1.225a1.01,1.01,0,0,0,.419.283,1.729,1.729,0,0,0,.607.1,1.6,1.6,0,0,0,.72-.138.836.836,0,0,0,.385-.358,1.809,1.809,0,0,0,.112-.758,1.833,1.833,0,0,1-.614.422,1.951,1.951,0,0,1-.728.128,2,2,0,0,1-1.505-.643,2.5,2.5,0,0,1,.036-3.32,1.941,1.941,0,0,1,1.408-.578,1.873,1.873,0,0,1,.722.14,2.292,2.292,0,0,1,.681.462Zm-1.151.923a1.157,1.157,0,0,0-.867.352,1.22,1.22,0,0,0-.342.885,1.236,1.236,0,0,0,.35.908,1.183,1.183,0,0,0,.879.354,1.139,1.139,0,0,0,.853-.346,1.248,1.248,0,0,0,.336-.908,1.233,1.233,0,0,0-.338-.9A1.164,1.164,0,0,0,523.67,676.092Z",
    transform: "translate(-465.175 -673.346)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M538.583,684.977a.617.617,0,0,1,.452.186.639.639,0,1,1-.9,0A.616.616,0,0,1,538.583,684.977Z",
    transform: "translate(-476.111 -679.887)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M554.256,671.338l-.844.744a1.2,1.2,0,0,0-.9-.618.549.549,0,0,0-.367.12.349.349,0,0,0-.143.27.464.464,0,0,0,.1.285,7.625,7.625,0,0,0,.836.769q.652.546.791.688a2.389,2.389,0,0,1,.491.67,1.675,1.675,0,0,1,.144.7,1.6,1.6,0,0,1-.509,1.216,1.856,1.856,0,0,1-1.328.48,1.978,1.978,0,0,1-1.114-.313,2.479,2.479,0,0,1-.813-.985l.958-.578q.432.793.994.793a.732.732,0,0,0,.493-.171.508.508,0,0,0,.2-.395.681.681,0,0,0-.151-.407,4.377,4.377,0,0,0-.664-.622,6.667,6.667,0,0,1-1.264-1.231,1.56,1.56,0,0,1-.285-.864,1.414,1.414,0,0,1,.475-1.068,1.645,1.645,0,0,1,1.171-.445,1.847,1.847,0,0,1,.854.207A3.119,3.119,0,0,1,554.256,671.338Z",
    transform: "translate(-484.454 -670.26)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M564.381,670.039a.678.678,0,0,1,.5.212.728.728,0,0,1,0,1.019.671.671,0,0,1-.495.209.681.681,0,0,1-.5-.214.715.715,0,0,1-.209-.519.707.707,0,0,1,.706-.708Zm-.555,1.823h1.111v4.427h-1.111Z",
    transform: "translate(-493.075 -670.039)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M570.315,675.169h1.111v.509a1.893,1.893,0,0,1,.633-.468,1.854,1.854,0,0,1,.759-.154,1.415,1.415,0,0,1,.749.2,1.471,1.471,0,0,1,.537.594,1.8,1.8,0,0,1,.65-.594,1.773,1.773,0,0,1,.841-.2,1.554,1.554,0,0,1,.831.22,1.274,1.274,0,0,1,.515.574A3.071,3.071,0,0,1,577.1,677v2.6h-1.119V677.35a1.919,1.919,0,0,0-.187-1.019.642.642,0,0,0-.561-.266.853.853,0,0,0-.511.163.963.963,0,0,0-.336.45,2.785,2.785,0,0,0-.11.922v2h-1.119v-2.145a3.03,3.03,0,0,0-.088-.86.784.784,0,0,0-.263-.4.694.694,0,0,0-.424-.13.84.84,0,0,0-.5.165.984.984,0,0,0-.338.462,2.851,2.851,0,0,0-.112.936V679.6h-1.111Z",
    transform: "translate(-497.452 -673.346)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M594.429,675.169v.488a2.084,2.084,0,0,1,.651-.452,1.877,1.877,0,0,1,.749-.15,1.934,1.934,0,0,1,1.473.655,2.376,2.376,0,0,1,.606,1.681,2.318,2.318,0,0,1-.627,1.654,1.973,1.973,0,0,1-1.485.666,1.847,1.847,0,0,1-.712-.136,2.174,2.174,0,0,1-.655-.446v2.087h-1.1v-6.046Zm1.167.911a1.159,1.159,0,0,0-.871.358,1.29,1.29,0,0,0-.346.936,1.329,1.329,0,0,0,.346.954,1.15,1.15,0,0,0,.871.364,1.13,1.13,0,0,0,.857-.37,1.451,1.451,0,0,0,.006-1.878A1.133,1.133,0,0,0,595.6,676.08Z",
    transform: "translate(-512.623 -673.346)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M615.239,670.039a.677.677,0,0,1,.5.212.728.728,0,0,1,0,1.019.67.67,0,0,1-.495.209.681.681,0,0,1-.505-.214.715.715,0,0,1-.209-.519.707.707,0,0,1,.706-.708Zm-.555,1.823h1.111v4.427h-1.111Z",
    transform: "translate(-526.604 -670.039)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M619.644,671.862h.395q0-.87.028-1.03a.848.848,0,0,1,.307-.579,1.147,1.147,0,0,1,.743-.214,2.31,2.31,0,0,1,.782.159v.846a1.487,1.487,0,0,0-.395-.07.417.417,0,0,0-.285.082.352.352,0,0,0-.065.253l0,.553h.7v.94h-.7v3.487h-1.111V672.8h-.395Z",
    transform: "translate(-529.973 -670.039)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M627.944,670.039a.676.676,0,0,1,.5.212.728.728,0,0,1,0,1.019.67.67,0,0,1-.495.209.681.681,0,0,1-.505-.214.715.715,0,0,1-.209-.519.707.707,0,0,1,.706-.708Zm-.555,1.823H628.5v4.427h-1.111Z",
    transform: "translate(-534.979 -670.039)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M637.937,677.7h-3.568a1.186,1.186,0,0,0,.413.751,1.3,1.3,0,0,0,.857.279,1.481,1.481,0,0,0,1.07-.436l.936.44a2.213,2.213,0,0,1-.838.734,2.625,2.625,0,0,1-1.16.238,2.293,2.293,0,0,1-1.7-.657,2.239,2.239,0,0,1-.655-1.646,2.313,2.313,0,0,1,.653-1.683,2.194,2.194,0,0,1,1.638-.669,2.276,2.276,0,0,1,1.7.669,2.421,2.421,0,0,1,.655,1.768Zm-1.111-.875a1.117,1.117,0,0,0-.434-.6,1.26,1.26,0,0,0-.752-.232,1.33,1.33,0,0,0-.815.261,1.446,1.446,0,0,0-.407.573Z",
    transform: "translate(-538.972 -673.346)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M666.959,684.977a.616.616,0,0,1,.451.186.638.638,0,1,1-.9.9.636.636,0,0,1,.452-1.087Z",
    transform: "translate(-560.745 -679.887)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M433.331,672.232V670.6h0l-1.11.673v.959h-.57v.956h.57v3.471h1.111v-3.471h.659v-.956Z",
    transform: "translate(-406.036 -670.409)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M610.222,670.374l-1.11.673v5.462h1.111v-6.136Z",
    transform: "translate(-523.03 -670.26)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M489.306,671.047v5.462h1.111v-6.136Z",
    transform: "translate(-444.046 -670.26)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M496.277,670.374l-1.11.673v5.462h1.111v-6.136Z",
    transform: "translate(-447.911 -670.26)",
    fill: "#082040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M652.432,671.047v1.524a2.031,2.031,0,0,0-.646-.452,1.873,1.873,0,0,0-.747-.15,1.93,1.93,0,0,0-1.471.655,2.376,2.376,0,0,0-.606,1.681,2.32,2.32,0,0,0,.626,1.654,1.969,1.969,0,0,0,1.483.666,1.831,1.831,0,0,0,.709-.136,2.185,2.185,0,0,0,.652-.446v.468h1.111v-6.136Zm-.3,4.2a1.143,1.143,0,0,1-.867.364,1.126,1.126,0,0,1-.854-.37,1.327,1.327,0,0,1-.346-.944,1.313,1.313,0,0,1,.341-.934,1.122,1.122,0,0,1,.856-.364,1.158,1.158,0,0,1,.872.358,1.292,1.292,0,0,1,.345.936A1.331,1.331,0,0,1,652.135,675.242Z",
    transform: "translate(-549.3 -670.26)",
    fill: "#082040"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeyondwallsLogoirfs);
export default __webpack_public_path__ + "static/media/beyondwalls-logoirfs.afae0450f4a06c96590a8a2baa3154ba.svg";
export { ForwardRef as ReactComponent };